// extracted by mini-css-extract-plugin
export default {"nextStepBtn":"flights-list_nextStepBtn__MwdmL","tableContainer":"flights-list_tableContainer__xyM-P"};